// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1K_Z0","col":"styles_col__3opaU"};